import FinishAccountSetup from 'components/account-setup/FinishAccountSetup'
import AppAuth from 'components/app/AppAuth';
import ScrollToTop from 'components/app/modules/scrollToTop/ScrollToTop';
import AppBar from 'components/common/controls/navbar/AppBar';
import restrictRoute from 'components/guards/router/RestrictRoute';
import ModalContainer from 'components/modal/ModalContainer';
import EventRedirectComponent from 'components/redirect/eventredirect';
import RedirectComponent from 'components/redirect/redirect'
import { FontSizes } from 'lib/styles/Typography';
import { RouteTo } from 'lib/utils/routing';
import { LoginPage } from 'pages/auth/login/Login.page';
import LogoutPage from 'pages/auth/logout/Logout.page';
import SettingsPage from 'pages/auth/Settings.page';
import DashboardDefaulPage from 'pages/dashboard/Overview.page';
import EventPrivateCheckInPage from 'pages/event/private/CheckIn.page';
import MoreEventsBy from 'pages/event/public/components/MoreEventsBy';
import LandingPage from 'pages/Landing.page';
import CreateEventPage from 'pages/manage/events/create/CreateEvent.page';
import EventDetailPage from 'pages/manage/events/detail/EventDetail.page';
import EditEventsPage from 'pages/manage/events/edit/EditEvent.page';
import ManageEventsPage from 'pages/manage/events/manage/ManageEvents.page';
import ActivateDigitalTicketPage from 'pages/manage/tickets/activate/digital/ActivateDigitalTicket.page';
import ReceiptPage from 'pages/ticket/receipt/Receipt.page';
import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import Helmet from 'react-helmet';
import { Provider } from 'react-redux';
import { Route, Router, Switch } from 'react-router';
import { Elements } from 'react-stripe-elements';
import { history, store } from 'stores/store.js';
import styled from 'styled-components';
import './app.css';
import PaymentSetup from './StripeConnect/PaymentSetup';

const AppDiv = styled.div`
	font-size: ${FontSizes.normal};
	min-height: 100vh !important;
`;

/**
 * Main routing component.
 */
class App extends Component<{ [label: string]: any }> {

	constructor(props) {
		super(props);
	}

	public render() {
		return (
			<Router history={history} >
				<Provider store={store}>
					<Elements>
						<AppDiv className='app'>

							{/* html metadata */}
							<Helmet
								title={'ISOTOPE | Backstage'}
								meta={[
									{ name: 'author', content: "ISOTOPE ticketing" },
									{ name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=yes' },
									{ property: 'og:title', content: 'ISOTOPE Ticketing' },
									{ property: 'og:site_name', content: "ISOTOPE" },
									{ property: 'og:image', content: "https://www.isotopeticketing.com/images/og-image.jpg" },
									{ property: 'og:site_name', content: "ISOTOPE" },
									{ property: 'og:image:width', content: '1428' },
									{ property: 'og:image:height', content: '748' },
									{ property: 'theme-color', content: '#000000' },
									{ property: 'charset', content: 'utf-8' },
									{ property: "google-site-verification", content: "zGFGX-x2yPoIdPnYyLJSxqwLu1gDg_OcKKahDfBpqMY" },
									{ property: "og:image:secure_url", content: "https://www.isotopeticketing.com/images/og-image.jpg" },
									{ property: 'description', content: 'Isotope Ticketing & Event Management Platform' },
								]}
							/>

							{/* Modal */}
							<ModalContainer />

							{/* Check for whether user is logged in already using cookie data */}
							<AppAuth />

							{/* Navbar */}
							<div className='stick'>
								<AppBar />
							</div>

							{/* All routes */}
							<div className='mainpage'
								style={{
									marginTop: // window.location.pathname !== '/' && window.location.pathname !== '/login' && window.location.pathname !== '/logout' ?
										screen.width <= 500 ? '135px' : '110px'
									// : '0px' 
								}}
							>
								<ScrollToTop>
									<Switch>

										{/* Public routes */}

										<Route exact={true} path='/' component={LandingPage} />
										<Route exact={true} path='/login' component={LoginPage} />
										<Route exact={true} path='/logout' component={LogoutPage} />

										{/* Stripe after connect express setup redirect component */}
										<Route
											path='/paymentCallBack'
											component={PaymentSetup}
										/>

										{/* Receipt page */}
										<Route
											path={RouteTo.ticketPublic(':ticketCode')}
											component={ReceiptPage}
										/>

										{/* Account invite setup / forgot password link */}
										<Route
											exact={true}
											path={RouteTo.oneTimeLink(':email', ':password')}
											component={FinishAccountSetup}
										/>

										{/* Private routes */}

										{/* Overview page */}
										<Route
											exact={true}
											path='/dashboard/overview'
											component={restrictRoute(DashboardDefaulPage)}
										/>

										{/* Events page */}
										<Route
											exact={true}
											path={RouteTo.manageEvents()}
											component={restrictRoute(ManageEventsPage)}
										/>

										{/* Event details settings page */}
										<Route
											exact={true}
											path={RouteTo.eventEdit(':eventId')}
											component={restrictRoute(EditEventsPage)}
										/>

										{/* Event dashboard */}
										<Route
											exact={true}
											path={RouteTo.eventDetail(':eventId')}
											component={restrictRoute(EventDetailPage)}
										/>

										{/* Checkin page */}
										<Route
											exact={true}
											path={RouteTo.eventCheckIn(':eventId')}
											component={restrictRoute(EventPrivateCheckInPage)}
										/>

										{/* Referral checkout page */}
										<Route
											path={RouteTo.eventEdit(':eventId')}
											component={restrictRoute(EditEventsPage)}
										/>

										{/* Inventories, team, annoucements and other settings besides details */}
										<Route
											exact={true}
											path={RouteTo.eventCreate()}
											component={restrictRoute(CreateEventPage)}
										/>

										{/* Account settings */}
										<Route
											exact={true}
											path={'/settings'}
											component={restrictRoute(SettingsPage)}
										/>

										{/* More events by page */}
										<Route
											exact={true}
											path={RouteTo.moreEventsBy(':userId', ':hostname')}
											component={MoreEventsBy}
										/>

										{/* Sell page */}
										<Route
											exact={true}
											path={RouteTo.eventActivateDigital(':eventId')}
											component={restrictRoute(ActivateDigitalTicketPage)}
										/>

										{/* Redirects shortened URLS to the matching checkout page */}
										<Route
											path={RouteTo.eventLinkRedirect(':code')}
											component={EventRedirectComponent}
										/>

										{/* Redirects private ticket code to its checkout page */}
										<Route
											path={RouteTo.printedTicketRedirect(':ticketCode')}
											component={RedirectComponent}
										/>

									</Switch>
								</ScrollToTop>
							</div>
						</AppDiv>
					</Elements>
				</Provider>
			</Router >
		);
	}
}

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/components/app/App.tsx